import { ReactionBadges } from '@web/conversations/Reactions/ReactionBadges/ReactionBadges';
import { ReactionButton } from '@web/conversations/Reactions/ReactionButton/ReactionButton';
import { ReactionPositionedSelect } from '@web/conversations/Reactions/ReactionPositionedSelect/ReactionPositionedSelect';

import { usePicker, useReactions } from './messageReactions.hooks';
import { Inner, Wrapper } from './messageReactions.styles';

export type Props = {
  messageId: number;
};

export const MessageReactions = ({ messageId }: Props) => {
  const { badges, canReact, onSelect } = useReactions(messageId);
  const { handleButtonClick, isOpen, onPick, position, ref } = usePicker({ onSelect });

  return badges.length ? (
    <Wrapper>
      <ReactionBadges badges={badges} handleClick={onSelect} />

      {canReact && (
        <Inner ref={ref}>
          {isOpen && <ReactionPositionedSelect handleSelect={onPick} position={position} />}
          <ReactionButton handleClick={handleButtonClick} isActive={isOpen} label="+" />
        </Inner>
      )}
    </Wrapper>
  ) : null;
};
